import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { ProviderVM } from "@shared-kernel/application/ports/provider/provider-repository";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import { retrieveProviderProfile } from "@user-management-context/read/application/use-cases/provider/provider-profile-retrieval/retrieve-provider";

const initialState: RetrievalState<Nullable<ProviderVM>> = { fetching: "idle", data: null };

export const retrieveProviderProfileReducer = createReducer<RetrievalState<Nullable<ProviderVM>>>(initialState, builder => {
  builder.addCase(retrieveProviderProfile.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveProviderProfile.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveProviderProfile.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
